import { useContext } from 'react';

import DetailTabBar from '@atom/components/common/detailTabBar/DetailTabBar';
import { useNavigation } from '@atom/hooks/useNavigation';
import { AssetDetailView } from '@atom/types/asset';

import InventoryDetailContext from '../InventoryDetailContext';

import { getViews } from './getViews';
import HeaderControls from './HeaderControls';
import HeaderFields from './HeaderFields';
import NavigationTitle from './NavigationTitle';

import classes from './header.module.css';

type InventoryDetailHeaderProps = {
  inventoryMoveDisabled: boolean;
};

const InventoryDetailHeader = ({
  inventoryMoveDisabled,
}: InventoryDetailHeaderProps) => {
  const { asset } = useContext(InventoryDetailContext);
  const [{ activeView }, { updateSearchParams }] = useNavigation();

  const views = getViews(asset);

  const currentView: AssetDetailView =
    (activeView as AssetDetailView) || AssetDetailView.ASSET_INFO;

  const setActiveView = (view: string) => {
    updateSearchParams({ activeView: view || AssetDetailView.ASSET_INFO });
  };

  return (
    <div className={classes.headerContainer}>
      <NavigationTitle />
      <HeaderControls inventoryMoveDisabled={inventoryMoveDisabled} />
      <HeaderFields />
      <div className={classes.iconRow}>
        <DetailTabBar
          tabs={views}
          activeTab={currentView}
          onChange={setActiveView}
          dataCy="inventoryDetailTabBar"
        />
      </div>
    </div>
  );
};

export default InventoryDetailHeader;
